import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList } from 'lucide-react';

export const labDirectorNav = (isHovered, styles) => (
     <>
          <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <Home size={20} />
               {isHovered && <span>Dashboard</span>}
          </NavLink>
          {/* http://localhost:3000/admin-evaluations */}
          <NavLink to="/admin-evaluations" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <ClipboardList size={20} />
               {isHovered && <span>Consultants Evaluations</span>}
          </NavLink>


     </>
);